"use strict";

var clientRect = require("app/util/browser/client-rect.js");

module.exports.autoScrollToShowElement = function autoScrollToShowElement(element, position, speed) {
  speed = speed || 200;

  //Top Position relative to the document
  var relativeTop = clientRect.getTopRelativeToDocument(element);

  var yCoordinate;

  if (position === "bottom") {
    yCoordinate = calculatePositionForBottom(relativeTop, element);
  } else if (position === "top") {
    yCoordinate = relativeTop;
  }

  scrollTopToPosition(yCoordinate, speed);
};

module.exports.calculatePositionForBottom = calculatePositionForBottom;
function calculatePositionForBottom(relativeTop, element) {
  return relativeTop + element.offsetHeight - window.innerHeight;
}

//Scrolls page to specified position
module.exports.scrollTopToPosition = scrollTopToPosition;
function scrollTopToPosition(yCoordinate, speed) {
  $("html, body").animate({ scrollTop: yCoordinate }, speed);
}

module.exports.scrollLeftToPosition = scrollLeftToPosition;
function scrollLeftToPosition(xCoordinate, speed) {
  $("html, body").animate({ scrollLeft: xCoordinate }, speed);
}



// WEBPACK FOOTER //
// ./app/util/browser/animation.js